
import { escapeEmptyDetail } from '../../utils/utils';
import DetailItem from '../../components/DetailItem/DetailItem';
import StripedTable from "../../components/Table/StripedTable";
import React, {useState} from "react";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import StakeholderInfoModal from './../../components/StakefolderInfoModal/StakeholderInfoModal';

export const StakeholdersDetails = ({ newStakeholders, oldStakeholders, stakeholders, registryStakeholders }) => {

    const headings = ['Organization Name', 'Organization Id', 'Stakeholder Role']
    const [isModalOpen, setIsModalOpen] = useState(false);


    const buildStakeholdersRow = (stakeholders, title) => {
        return (
            <DetailItem title={title} content={
                <>
                    <HelpOutlineIcon style={{float: 'right', cursor: 'pointer'}} onClick={() => setIsModalOpen(true)}>?</HelpOutlineIcon>
                    <StripedTable
                        aria-label='simple table'
                        headings={headings}
                        rows={stakeholders?.map((data, index) => {
                            if (data) {
                                return {
                                    elements: [
                                        <p>{escapeEmptyDetail(data.organizationName)}</p>,
                                        <p>{escapeEmptyDetail(data.organizationId)}</p>,
                                        <p>{escapeEmptyDetail(data.roleType)}</p>],
                                };
                            } else {
                                return {
                                    elements: [],
                                };
                            }
                        })}
                    ></StripedTable>
                </>
            } />
        )
    }
    return (
        <>
            { oldStakeholders && oldStakeholders.length > 0 &&
                buildStakeholdersRow(oldStakeholders, 'Old Stakeholders')
            }
            { newStakeholders && newStakeholders.length > 0 &&
                buildStakeholdersRow(newStakeholders, 'New Stakeholders')
            }
            { stakeholders && stakeholders.length > 0 &&
                buildStakeholdersRow(stakeholders, 'Stakeholders')
            }
            { registryStakeholders && registryStakeholders.length > 0 &&
                buildStakeholdersRow(registryStakeholders, 'Registry Stakeholders')
            }
            { isModalOpen &&
                <StakeholderInfoModal open={isModalOpen} onClose={() => setIsModalOpen(false)} />
            }
        </>
    );
};
